/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleEnum } from './RoleEnum';
import {
    RoleEnumFromJSON,
    RoleEnumFromJSONTyped,
    RoleEnumToJSON,
    RoleEnumToJSONTyped,
} from './RoleEnum';

/**
 * 
 * @export
 * @interface PatchedMembership
 */
export interface PatchedMembership {
    /**
     * 
     * @type {number}
     * @memberof PatchedMembership
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedMembership
     */
    readonly userId?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedMembership
     */
    readonly firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMembership
     */
    readonly lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMembership
     */
    readonly displayName?: string;
    /**
     * 
     * @type {RoleEnum}
     * @memberof PatchedMembership
     */
    role?: RoleEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedMembership
     */
    readonly avatarUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMembership
     */
    readonly email?: string;
}



/**
 * Check if a given object implements the PatchedMembership interface.
 */
export function instanceOfPatchedMembership(value: object): value is PatchedMembership {
    return true;
}

export function PatchedMembershipFromJSON(json: any): PatchedMembership {
    return PatchedMembershipFromJSONTyped(json, false);
}

export function PatchedMembershipFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedMembership {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'displayName': json['display_name'] == null ? undefined : json['display_name'],
        'role': json['role'] == null ? undefined : RoleEnumFromJSON(json['role']),
        'avatarUrl': json['avatar_url'] == null ? undefined : json['avatar_url'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

  export function PatchedMembershipToJSON(json: any): PatchedMembership {
      return PatchedMembershipToJSONTyped(json, false);
  }

  export function PatchedMembershipToJSONTyped(value?: Omit<PatchedMembership, 'id'|'user_id'|'first_name'|'last_name'|'display_name'|'avatar_url'|'email'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'role': RoleEnumToJSON(value['role']),
    };
}

